import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { IDefaultResponseT } from '../../models/default-response/response';
import { LIVESTREAMS_ROUTE } from '../http-routes';
import { ILivestreamConfig } from '../../models/livestream/livestream-config';
import { IMatchOverlayConfig } from '../../models/overlay/match-overlay-config';

@Injectable({
  providedIn: 'root',
})
export class LivestreamsHttpService {
  constructor(private http: HttpService) {}

  public async getLivestreamConfig(
    eventId: string
  ): Promise<ILivestreamConfig> {
    const response = await this.http.get<IDefaultResponseT<ILivestreamConfig>>([
      LIVESTREAMS_ROUTE,
      'config/event',
      eventId,
    ]);
    return response.data;
  }

  public async getMatchOverlayData(
    eventId: string
  ): Promise<IMatchOverlayConfig> {
    const response = await this.http.get<
      IDefaultResponseT<IMatchOverlayConfig>
    >([LIVESTREAMS_ROUTE, 'overlay/event', eventId]);
    return response.data;
  }

  public async postEventChangeToStaigeHLS(eventId: string) {
    return this.http
      .patch([LIVESTREAMS_ROUTE, 'events/staige/hls', eventId])
      .toPromise();
  }

  public async pathSetLiveCommentary(eventId: string, liveCommentary: boolean) {
    return this.http
      .patch([LIVESTREAMS_ROUTE, '/set/live-commentary', eventId], {
        live_commentary: liveCommentary,
      })
      .toPromise();
  }

  public async postResetOverlay(eventId: string) {
    return this.http
      .patch([LIVESTREAMS_ROUTE, 'overlays/event', eventId], {
        action: 'reset',
      })
      .toPromise();
  }

  public async postDeleteOverlay(eventId: string) {
    return this.http
      .patch([LIVESTREAMS_ROUTE, 'overlays/event', eventId], {
        action: 'remove',
      })
      .toPromise();
  }
}
